/* eslint-disable semi */
/* eslint-disable comma-dangle */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Fragment } from 'react'
import { Slide, toast } from 'react-toastify'

import baseurl from '../../../@core/auth/jwt/baseurl'
import emiter from '../../../utility/hooks/emiiter'

const showErrorMsg = (error) => {
  toast.error(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Error</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{error}</span>
      </div>
    </Fragment>,
    {
      icon: false,
      transition: Slide,
      hideProgressBar: false,
      autoClose: 1500,
      position: toast.POSITION.TOP_CENTER
    }
  )
}

export const getData = createAsyncThunk(
  'appInvoice/getData',
  async (params) => {
    const response = await baseurl.get('/api/app/invoice', {
      params
    })
    return {
      params,
      data: response.data.items,
      total: response.data.totalCount
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const deleteInvoice = createAsyncThunk(
  'appInvoice/deleteInvoice',
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.delete(`/api/app/invoice/${id}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 204) {
        emiter.emit('close-invoice-delete-popup')
        await dispatch(getData(getState().invoice.params))
        return id
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const appInvoiceSlice = createSlice({
  name: 'appInvoice',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedInvoice: null,
    loading: true,
    getByIdLoading: false,
    initLoading: false,
    saveLoading: false
  },
  reducers: {
    setUploads: (state, action) => {
      state.selectedInvoice = {
        ...state.selectedInvoice,
        uploads: action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.rejected, (state) => {
        state.loading = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.total
        state.loading = false
      })

      .addCase(deleteInvoice.pending, (state) => {
        state.deleteLoading = true
      })
      .addCase(deleteInvoice.rejected, (state) => {
        state.deleteLoading = false
      })
      .addCase(deleteInvoice.fulfilled, (state) => {
        state.deleteLoading = false
      })

  }
})

export const { setUploads } = appInvoiceSlice.actions
export default appInvoiceSlice.reducer
